import React from "react"

import { clusterItemRequest } from "../../actions/cluster-actions"

import pageComponent from "../common/page-component-hoc"

import ClusterListWidgetContainer from "./cluster-list/ClusterListWidgetContainer"
import Cluster from "./cluster-item/Cluster"

const ClusterComponent = () => (
    <div className="widgets-container clearfix row">
        <div
            className="col-xs-12 col-md-6 col-lg-5 col-xl-4 widget-list"
            id="cluster-list"
        >
            <ClusterListWidgetContainer />
        </div>
        <Cluster />
    </div>
)

export default pageComponent("clusters", clusterItemRequest)(ClusterComponent)
